<template>
  <div>
    <footer :class="isRTL ? 'rtl' : ''">
      <div>
        <div class="wrapper pt-0">
          <!-- <div class="feedback-box">
          <div class="row justify-content-center">
            <div class="col-sm-4 text-center">
             <img src="@/assets/img/svg/headphones.svg" width="50" height="auto">
             <p class="ftwx text-uppercase pt-2 mb-0">24/7 customer care</p>
            </div>

            <div class="col-sm-4 text-center b-box py-3 py-md-0">
              <img src="@/assets/img/svg/ticket-alt-solid.svg" width="50" height="auto">
              <p class="ftwx text-uppercase pt-2 mb-0">resend booking confirmation</p>
            </div>

            <div class="col-sm-4 text-center">
              <img src="@/assets/img/svg/envelope-open-regular.svg" width="50" height="auto">
              <p class="ftwx text-uppercase pt-2 mb-0">subscribe to newsletter</p>
            </div>
          </div> 
          <hr  style="background-color: #af5688">
          </div>-->

          <div class="row align-items-center pb-lg-3">
            <div class="col-12 col-md-5 col-lg-3" >

              <div >    
               <img
                  v-on:click="onClickLogo()"
                  src="@/assets/img/newlogo.png"
                  class="nav-brand mob_logo_header"
                  alt="Wanasa"
                  
                 
                />
<!--data-aos="fade-right"  data-aos-duration="1000"-->
              <img
                v-if="project == 'ticketak' && false"
                src="@/assets/img/tt-logo.png"
                class="logo-img"
                alt="Ticketak"
              />
              <img
                v-if="project == 'myticketi' && false"
                src="@/assets/img/428×188_logo.png"
                class="logo-img"
                alt="Mytiketi"
              />
          </div>
              <p class="font-weight-bold mt-4 mb-3">{{$t("BOOK_YOUR_TICKET")}}</p>
              <div class="row button-icon" v-if="project == 'ticketak' && false">
                <div class="col-6 col-md-6 col-lg-4 pl-0 pl-md-1 pr-0">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://apps.apple.com/in/app/ticketak/id1454492437"
                  >
                    <img src="@/assets/img/applestore.png" alt="App Store" />
                  </a>
                </div>
                <div class="col-6 col-md-6 col-lg-4 pr-0 pr-md-0 pl-0">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.ticketak.ticketak"
                  >
                    <img src="@/assets/img/googlestore.png" alt="Google Store" />
                  </a>
                </div>
              </div>
              <div class="row button-icon" :class="isRTL ? 'mobile_icon_footer' : ''">
                <div class="custom_width_new"><!--col-6 col-md-6 col-lg-4 pl-2 pl-md-1-->
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://apps.apple.com/us/app/wanasatime/id1187788688"
                    
                  >
                    <!--img src="@/assets/img/applestore.png" alt="Apple Store" /-->
                   
                    <img src="@/assets/img/appledownload.svg" alt="Apple Store" />
                   
                  </a>
                </div>
                <div class="custom_width_new"><!--col-6 col-md-6 col-lg-4 pr-2 pr-md-1-->
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.mobile.android.wanasatime&hl=en_US"
                  >
                  <!--iframe src="https://embed.lottiefiles.com/animation/27173"
                  class="playstore_anima"
                  ></iframe-->
                    <!--img src="@/assets/img/googlestore.png" alt="Google Store" /-->
                    <img src="@/assets/img/google.svg" alt="Google Store" />
                   
                  </a>
                </div>
              </div>
            </div>
            

        <div class="col-12 col-md-7 col-lg-9 footer-list py-3 py-md-0">
          <div class="row">
              <div class="col-12">
            <p>{{$t("WanasaTime_TELEBU_COMMUNICATIONS")}}
              </p>
              </div>

              <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 mt-4 footer_static_pages" 
              :class="isRTL ? 'text-xl-center pl-xl-5' : ''"
              >
                  <span v-on:click="aboutUs()">{{$t("ABOUT")}} &nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp; </span>
                  <span v-on:click="faq()">{{$t("FAQ")}}  &nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp; </span>
                  <span v-on:click="terms()">{{$t("TERMS_CONDITION")}}&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp; </span>
                  <span  v-on:click="privacy()">{{$t("PRIVACY_POLICY")}}&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp; </span>
                  <span v-on:click="contact()">{{$t("CONTACT_US")}} &nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp; </span>
                  <span v-on:click="pricing()">{{$t("PLAN_PRICING")}}</span>
                 
              </div>

                <div class="col-xl-3 mt-4   
                footer_icons col-lg-12 col-md-12 col-sm-12" 
                :class="isRTL ? 'mobile_icon_footer' : 'd-flex justify-content-xl-end'">
                  <a href="https://www.facebook.com/wanasatimebahrain/" target="_blank">
                  <img src="@/assets/img/icons/facebook.svg"  class="mr-3"/>
                  </a>

                  <a href="https://www.instagram.com/wanasatimebahrain/" target="_blank" >
                   <img src="@/assets/img/icons/instagram.svg" class="mr-3"/>
                    </a>

                    <a href="https://wa.me/97333565333" target="_blank">
                    <img src="@/assets/img/icons/whatsapp.svg"  class="mr-3"/>
                     </a>

                     <a href="https://www.youtube.com/channel/UCGFYBcAvN-nRdNedByeDKdg " target="_blank">
                     <img src="@/assets/img/icons/youtube.svg"  class="mr-3"/>
                      </a>

              </div>
          </div>
          
        </div>

            <div class="col-12 col-md-7 col-lg-6 footer-list py-3 py-md-0" v-if="false">
              <div class="row">
                <div class="col-md-4">
                  <span class="footer_title" v-if="project == 'myticketi'" style="color:transparent">Cinema Partners</span>
                  <ul class="list-unstyled ">
                    <li>
                      <router-link to="/movies">Find a movie</router-link>
                    </li>
                    <li>
                      <router-link to v-on:click.native="scroll()">In Theaters</router-link>
                    </li>
                    <li>
                      <router-link to="/cinemas">More Theaters Nearby</router-link>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <span class="footer_title" v-if="project == 'myticketi'" style="color:transparent">Cinema Partners</span>
                  <ul class="list-unstyled ">
                    <li>
                      <router-link to="/aboutus">About us</router-link>
                    </li>
                    <li>
                      <router-link v-b-modal.support to>Contact us</router-link>
                    </li>
                     <li>
                      <router-link to="/tnc">Terms and Conditions</router-link>
                    </li>

                    
                  </ul>
                </div>

                   
                
                <div class="col-md-4">
                      
                      <span class="footer_title" v-if="project == 'myticketi'">Cinema Partners</span>  
                  <ul class="list-unstyled ">
                  
                   <li v-if="project == 'myticketi'">
                     
                                          
                      <ul class="list-unstyled">
                        <li>
                          <a href="/cinema/century-cinemax">- Century Cinemax</a>
                        </li>
                        <li>
                          <a href="/cinema/anga-cinemas">- Anga Cinemas</a>
                        </li>
                        <li>
                          <a href="/cinema/metroplex">- Metro Plex Cinemas</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                
                

              </div>
            </div>
          </div>
          <hr class="mt-0 mt-md-2 footer-border" />
          <div class="d-none row align-items-end pt-2">
            <div class="col-12 col-md-6 text-md-left text-center mb-2 mb-md-0">
              <ul class="list-inline social-links mb-0">
                <li class="list-inline-item mr-md-5 mr-2">
                  <a target="_blank" rel="noreferrer" href="https://www.facebook.com/mytiketi">
                    <img src="@/assets/img/svg/facebook-icon.svg" alt="Facebook" />
                  </a>
                </li>
                <li class="list-inline-item mr-md-5 mr-2">
                  <a target="_blank" rel="noreferrer" href="https://twitter.com/mytiketi">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <path
                        style="fill:var(--purple);"
                        d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
	c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
	c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
	c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
	c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
	c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
	C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
	C480.224,136.96,497.728,118.496,512,97.248z"
                      />
                    </svg>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a target="_blank" rel="noreferrer" href="https://www.instagram.com/mytiketi/">
                    <svg
                      fill="var(--purple)"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160
			C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48
			h192c61.76,0,112,50.24,112,112V352z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336
			c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <circle cx="393.6" cy="118.4" r="17.056" />
                        </g>
                      </g>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-6 text-md-right text-center">
              <p class="ftwx mb-0">2019 Ticketak. All Rights Reserved.</p>
            </div>
          </div>
        </div>

        <div class="copy_right">
          <p>{{$t("COPYRIGHT_2022")}}.</p>

        </div>
      </div>
    </footer>
  </div>
</template>


<script>
import { PROJECT } from "@/helper/constant.js";
import $ from "jquery";
import {mapGetters} from 'vuex'

export default {
  name: "footer-main",
  components: {},
  data() {
    return {
      project: PROJECT,
      msg: "Welcome to Your Vue.js PWA",
      slickOptions: {
        slidesToShow: 3
      }
    };
  },
  methods: {
    scroll: function() {
      if (this.$route.path !== "/") {
        this.$router.push({ name: "Home" });
      } else {
        $("html, body").animate(
          {
            scrollTop: $("#quickbook").offset().top
          },
          1000
        );
      }
    },
    aboutUs: function(){
      this.$router.push("/aboutus")
    },
      terms: function(){
      this.$router.push("/tnc")
    },
       faq: function(){
      this.$router.push("/faq")
    },
     privacy: function(){
      this.$router.push("/privacy")
    },
      contact: function(){
      this.$router.push("/contact")
    },
      pricing: function(){
      this.$router.push("/pricing")
    },
    onClickLogo: function() {
      // this.getAllCountry();

      this.$router.push({ name: "Home" });
      // EventBus.$emit("onClickLogo");
    }
  },
   computed: {
    ...mapGetters(['isRTL']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/footer.vue